import { render } from "./HpoPatientModalSection.vue?vue&type=template&id=b3afea38"
import script from "./HpoPatientModalSection.vue?vue&type=script&lang=js"
export * from "./HpoPatientModalSection.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__